import React from 'react';

import { ErrorCard } from '../../../../../components/ErrorCard';

interface ErrorStateProps {
  error: Error;
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => (
  <ErrorCard
    title="Error loading distributors"
    message={error.message}
    onRetry={onRetry}
  />
);
